import { ReactElement, useContext } from "react";
import { IStrandProduction } from "../../../../types";
import { TextField } from "@mui/material";
import { formatDateTimeWithSeconds } from "../../../../system/utils";
import { SystemContext } from "../../../../context/systemContext";
import { getLanguage } from "../../../production/configuration/language";

interface IGeneralPanelProps {
  productionItem: IStrandProduction;
  billets: number;
}

const GeneralPanel = ({ productionItem, billets }: IGeneralPanelProps): ReactElement => {
  const systemContext = useContext(SystemContext);

  const temperature = {
    datetime: 0,
    value: 0
  };

  productionItem.variables.forEach(variable => {
    if (variable.datetime > temperature.datetime) {
      temperature.datetime = variable.datetime;
      temperature.value = variable.value as number;
    }
  });

  const totalBillets = `${billets} / ${productionItem.totalBillets}`;

  return(
    <div>
      <div className="display-flex-row flex-wrap">
        <div className="flex-grow-1" style={{ maxWidth: 1560 }}>
          <TextField className="form-control"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={"Machine"}
            defaultValue={productionItem.machine.name}/>

          <TextField className="form-control"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={"Mill Heat"}
            defaultValue={productionItem.millHeat}/>

          <TextField className="form-control"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={getLanguage(systemContext.languageCode).heatNumber}
            defaultValue={productionItem.heatNumber}/>

          <TextField className="form-control"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={getLanguage(systemContext.languageCode).grade}
            defaultValue={productionItem.steelCode}/>

          <TextField className="form-control-large"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true }}}
            label={getLanguage(systemContext.languageCode).begin}
            defaultValue={formatDateTimeWithSeconds(productionItem.beginDatetime)}/>

          <TextField className="form-control-large"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={getLanguage(systemContext.languageCode).end}
            defaultValue={formatDateTimeWithSeconds(productionItem.endDatetime)}/>

          <TextField className="form-control"
            variant="standard"
            size="small"
            slotProps={{ input: { readOnly: true, }}}
            label={systemContext.language.crew}
            defaultValue={productionItem.crew.name}/>

          {billets > 0 &&
            <TextField className="form-control"
              variant="standard"
              size="small"
              slotProps={{ input: { readOnly: true, }}}
              label="Total Order Billets"
              defaultValue={totalBillets}/>
          }
        </div>
      </div>
    </div>
  );
};

export default GeneralPanel;
